import { UserObj } from '@Reducers/User/Type';

export function getAccountType(account: UserObj['_accountId']) {
  const isIndividual = account?.accountType === 'individual';
  const isAccountHolder = account?.isAccountHolder;
  return isAccountHolder ? (isIndividual ? 'account-individual' : 'account-individual-company') : 'individual';
}
